"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationDto = /** @class */ (function () {
    function AuthenticationDto() {
    }
    return AuthenticationDto;
}());
exports.default = AuthenticationDto;
